import { ApplicationConfig, inject, provideAppInitializer, provideZonelessChangeDetection, ErrorHandler } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { routes } from './app.routes';
import { AppLoadService } from '@core/services/app-load.service';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { provideAuth } from '@core/auth/auth.provider';
import { provideQuillConfig } from 'ngx-quill/config';
import { formats, modules } from '@core/rich-editor.config';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

import { MonitoringErrorHandler } from './core/services/monitoring.errorhandler';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { provideDateFnsAdapter } from '@angular/material-date-fns-adapter';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { CUSTOM_DATE_FORMATS } from '@core/date-adapter.config';
import { enUS } from 'date-fns/locale';

async function initApp() {
  const appLoadService = inject(AppLoadService);
  await appLoadService.initAll();
}

// AG grid - can be reduced only to used modules (later improvement)
ModuleRegistry.registerModules([AllCommunityModule]);

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(initApp),
    {
      provide: ErrorHandler,
      useClass: MonitoringErrorHandler,
    },
    provideZonelessChangeDetection(),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideAuth(),
    provideQuillConfig({
      modules: modules,
      formats: formats,
    }),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        subscriptSizing: 'dynamic',
      },
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { restoreFocus: false },
    },
    provideDateFnsAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: enUS },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
  ],
};
